var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 16C1.16 16 0.783333 15.8042 0.47 15.4125C0.156667 15.0208 0 14.55 0 14V2C0 1.45 0.156667 0.979167 0.47 0.5875C0.783333 0.195833 1.16 0 1.6 0H6.4L8 2H14.4C14.84 2 15.2167 2.19583 15.53 2.5875C15.8433 2.97917 16 3.45 16 4V14C16 14.55 15.8433 15.0208 15.53 15.4125C15.2167 15.8042 14.84 16 14.4 16H1.6Z",
    fill: "#3474E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.0333891c6d58fc041d27980f2db4cd4b.svg";
export { ForwardRef as ReactComponent };